// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"165":"capital","177":"home","495":"drapeau","648":"departements"}[chunkId] || chunkId) + "." + {"47":"8c61e438","165":"288630a3","177":"e3e3e293","495":"243d8200","648":"4387b484"}[chunkId] + ".js";
};